//on doc load vanilla js

const headerHover = () => {
  const menuItemsWrap = document.querySelector('.header__inline-menu')
  const menuItems = menuItemsWrap.querySelectorAll('.list-menu__item')

  //get current active menu item
  const activeMenuItem = menuItemsWrap.querySelector('.list-menu__item.active')

  //on mouse in Menu items remove active class for all and add on hovered
  menuItems.forEach(item => {
    item.addEventListener('mouseover', function() {
      menuItems.forEach(item => {
        item.classList.remove('active')
      })
      this.classList.add('active')
    })

    //on mouse out remove active class
    item.addEventListener('mouseout', function() {
      this.classList.remove('active')
    })
  })

  menuItemsWrap.addEventListener('mouseout', function() {
    activeMenuItem.classList.add('active')
  })




}

const openMegaMenu = () => {
  const button = document.querySelector('.js-open-menu')
  const megaMenu = document.querySelector('.mega-menu')
  const closeBtn = megaMenu.querySelector('.js-close-menu')


  button.addEventListener('click', function() {
    megaMenu.classList.add('open')
    button.style.display = 'none'
    document.body.style.paddingTop = '7px'
    document.body.style.overflow = 'hidden'
  })

  closeBtn.addEventListener('click', function() {
    megaMenu.classList.remove('open')
    button.style.display = 'flex'
    document.body.style.paddingTop = '0px'
    document.body.style.overflow = 'auto'

    //.mega-menu__inner scroll to top
    const megaMenuInner = megaMenu.querySelector('.mega-menu__inner')
    megaMenuInner.scrollTop = 0
  })
}

const accordianHeaders = () => {

  const numberAccordian = document.querySelectorAll('.accordian')

  numberAccordian.forEach(function(accordian) {
    const title =  accordian.querySelector('.accordian__title')
    const rightText = accordian.querySelector('.accordian__content')
    //title height
    const titleHeight = title.offsetHeight
    const rightHeight = rightText.clientHeight




    if(titleHeight > rightHeight) {
      rightHeight.style.height = titleHeight + 'px'
    }else {
      title.style.height = rightHeight + 'px'
    }



    

  })
}

const accordians = () => {

  document.querySelectorAll('.accordian').forEach(function(accordianEl) {
    const accordianBlocks = accordianEl.querySelectorAll('.accordian__block');
    const mediaContainer = accordianEl.querySelector('.accordian__media');
  
    accordianBlocks.forEach(function(block) {
      block.addEventListener('click', function() {
        const isActive = block.classList.contains('active');
  
        // Close all accordian blocks in this accordian
        accordianBlocks.forEach(function(b) {
          b.classList.remove('active');
        });
  
        // Toggle clicked block
        if (!isActive) {
          block.classList.add('active');
          console.log('add');
        } else {
          console.log('remove');
        }
  
        // Handle media
        const blockId = block.getAttribute('data-block');
        const blockMedia = mediaContainer.querySelector(`.block-media[data-block="${blockId}"]`);
        console.log(blockMedia);
  
        if (blockMedia) {
          // Close all media in this accordian
          const allMedia = mediaContainer.querySelectorAll('.block-media');
          allMedia.forEach(function(media) {
            media.classList.remove('active');
          });
  
          if (!isActive) {
            blockMedia.classList.add('active');
          }
        }
      });
    });
  });  
}

  // Helper function to animate the count-up
  function countUp(element, target) {
    let start = 0;
    const duration = 2000; // Duration of animation in milliseconds
    const stepTime = Math.abs(Math.floor(duration / target));

    const interval = setInterval(() => {
      start += 1;
      element.textContent = start;
      if (start >= target) {
        clearInterval(interval);
      }
    }, stepTime);
  }

function initCountUp() {
  const elements = document.querySelectorAll('.js-count-up');

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const element = entry.target;
          const targetNumber = parseInt(element.textContent, 10);

          lockWidth(element); // Lock width before starting animation
          countUp(element, targetNumber);

          observer.unobserve(element); // Stop observing once the animation runs
        }
      });
    },
    {
      threshold: 0.5 // Trigger when 50% of the element is visible
    }
  );

  elements.forEach((element) => {
    observer.observe(element);
  });
}

  // Function to lock the width of the elements
  function lockWidth(element) {
    const computedStyle = window.getComputedStyle(element);
    const width = computedStyle.width;
    element.style.width = width; // Set the width explicitly
    element.style.overflow = "hidden"; // Ensure no overflow during animation
  }

  function expandableBlocks() {
    const allBlocks = document.querySelectorAll('.expandable-cards__card');
  
    allBlocks.forEach(block => {
      block.addEventListener('click', function () {
        const parent = block.closest('.expandable-cards__inner');
  
        // Check if this block is already expanded
        const isExpanded = block.classList.contains('expanded');
  
        // Remove "expanded" from all blocks in this parent
        const siblingBlocks = parent.querySelectorAll('.expandable-cards__card');
        siblingBlocks.forEach(sibling => sibling.classList.remove('expanded'));
  
        // Toggle clicked block back on if it wasn't already expanded
        if (!isExpanded) {
          block.classList.add('expanded');
        }
  
        // Update has-expanded class on parent
        const hasAnyExpanded = parent.querySelector('.expandable-cards__card.expanded');
        if (hasAnyExpanded) {
          parent.classList.add('has-expanded');
        } else {
          parent.classList.remove('has-expanded');
        }
      });
    });
  }



    // Function to initialize Swiper
    function initializeSwiper(section) { 
      const slidesMobile = parseFloat(section.getAttribute('data-slides-mobile'), 10) || 2;
      const slidesDesktop = parseFloat(section.getAttribute('data-slides-desktop'), 10) || 4;
      const spaceBetweenMobile = parseFloat(section.getAttribute('data-space-between-mobile'), 10) || 2;
      const spaceBetweenDesktop = parseFloat(section.getAttribute('data-space-between-desktop'), 10) || 2;
      const loop = section.getAttribute('data-loop') === 'true' || false;
  
      const experts = section.getAttribute('data-experts') === 'true';
      const autoplay = section.getAttribute('data-auto-scroll') === 'true';
      const expandable = section.getAttribute('data-expandable') === 'true';

      console.log(section.parentElement.parentElement);
  
  
  
      const nextBtn = section.parentElement.parentElement.querySelector('.swiper-button-next'); 
      const prevBtn = section.parentElement.parentElement.querySelector('.swiper-button-prev');
  
  
  
      const swiperInstance = new Swiper(section, {
          slidesPerView: slidesDesktop,
          spaceBetween: spaceBetweenDesktop,
          // simulateTouch: true,
          mousewheel: {
              forceToAxis: true, // Swipes only in the axis of movement
              sensitivity: 1, // Adjust for finer or coarser control
          },
          // slidesOffsetAfter: 330.665,
          autoplay: autoplay ? { 
              delay: 50, // Continuous scrolling (no delay between slides)
  
              // pauseOnMouseEnter: true
          } : false,
          speed: autoplay ? 4650 : 500, // Adjust scrolling speed for smoothness
          // freeMode: true, // Enable free mode for smooth scrolling
          loop: loop ? true : false, // Enable loop mode
          breakpoints: {
              320: {
                  slidesPerView: slidesMobile,
                  spaceBetween: spaceBetweenMobile,
              },
              1040: {
                  slidesPerView: slidesDesktop,
                  spaceBetween: spaceBetweenDesktop,
              }
          },
          navigation: {
              nextEl: nextBtn,
              prevEl: prevBtn,
          },
          pagination: {
              el: section.querySelector('.swiper-pagination'),
              type: 'bullets'
          },
      });
  
  
  
      
  

    
  
  
  
        
      
  
      
  

      
  
      return swiperInstance;
    }

  function initializeSwipers() {
    const sections = document.querySelectorAll('.swiper-container');
    sections.forEach(section => {
      if (section.swiper) section.swiper.destroy();
      initializeSwiper(section);
      section.style.opacity = 1;
    });
  }
  
  

document.addEventListener('DOMContentLoaded', function() {
  // headerHover()
  openMegaMenu()
  accordians()
  initCountUp()
  expandableBlocks()
  initializeSwipers()
  // accordianHeaders()
})

document.addEventListener('shopify:section:load', function() {

  

});
